import { makeStyles } from '@material-ui/core/styles';
import type { CSSProperties } from '@material-ui/core/styles/withStyles';

/** What a package publish did to a file, each with its own color. */
export type ChangeTone = 'added' | 'changed' | 'removed' | 'rejected' | 'unchanged' | 'folder';

const TONES: Record<ChangeTone, { text: string; accent: string; tint: string }> = {
  added: {
    text: 'var(--modern-success-light, #48AD3E)',
    accent: 'var(--modern-success, #128836)',
    tint: 'rgba(18, 136, 54, 0.14)',
  },
  changed: {
    text: 'var(--modern-info, #009DE0)',
    accent: 'var(--modern-info, #009DE0)',
    tint: 'rgba(0, 157, 224, 0.12)',
  },
  removed: {
    text: 'var(--modern-error-light, #FF335C)',
    accent: 'var(--modern-error, #E4002C)',
    tint: 'rgba(228, 0, 44, 0.12)',
  },
  // Not lost content, content that never got in: apart from removals.
  rejected: {
    text: '#F0804F',
    accent: '#E0653A',
    tint: 'rgba(224, 101, 58, 0.14)',
  },
  // Muted: nothing to act on.
  unchanged: {
    text: '#8E9BB3',
    accent: '#73839E',
    tint: 'rgba(115, 131, 158, 0.12)',
  },
  folder: {
    text: '#C2A66E',
    accent: '#A8894D',
    tint: 'rgba(168, 137, 77, 0.12)',
  },
};

/** `text`: a count or a reason; `item`: a list row with an accent bar and a tint. */
export const useToneStyles = makeStyles(
  Object.fromEntries(
    Object.entries(TONES).flatMap(([tone, { text, accent, tint }]) => [
      [`${tone}Text`, { fontWeight: 600, color: text }],
      [
        `${tone}Item`,
        {
          margin: 'var(--modern-spacing-1) 0',
          padding: 'var(--modern-spacing-2) var(--modern-spacing-3)',
          borderTop: 0,
          borderLeft: `3px solid ${accent}`,
          borderRadius: 'var(--modern-radius-sm)',
          background: tint,
        },
      ],
    ]),
  ) as Record<`${ChangeTone}${'Text' | 'Item'}`, CSSProperties>,
);
